//libraries
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import styled from 'styled-components';

// styles
import { Flex, ColumnedFlex, Link } from 'shared/styledComponents';
import { H3, Text } from 'shared/typography';

// custom components

// theme
import devices from 'theme/devices';

const Wrapper = styled(ColumnedFlex)`
  background-color: ${({ theme: { colors } }): string => colors.secondary};
  padding: 30px;
  margin-bottom: 70px;

  @media ${devices.mobile} {
    margin-bottom: 20px;
  }

  :last-child {
    margin-right: 0;
  }
`;

const Image = styled.img`
  width: 100%;
  max-width: 385px;
  margin-bottom: 30px;
`;

const Quote = styled(H3)`
  font-family: ${({ theme: { fonts } }): string => fonts.canelaThinItalic};
  margin-bottom: 25px;
`;

const Description = styled(Text)`
  margin-bottom: 30px;

  @media ${devices.mobile} {
    font-size: 14px;
    line-height: 22px;
  }
`;

const Services = styled(Flex)``;

const ServiceLink = styled(Link)`
  text-decoration: underline;
  margin-right: 15px;

  :last-child {
    margin-right: 0;
  }
`;

interface SearchStoryPreviewProps {
  imageUrl: string;
  quote: string;
  description: string;
  services: any[];
}

const SearchStoryPreview = ({ imageUrl, quote, description, services }: SearchStoryPreviewProps): JSX.Element => (
  <Wrapper>
    <Image src={imageUrl} />
    <Quote as="q">{quote}</Quote>
    <Description>{description}</Description>
    <Services>
      {services.map(({ id, name }) => (
        <ServiceLink key={id} as={ReactRouterLink} to="/" size="small">
          {name}
        </ServiceLink>
      ))}
    </Services>
  </Wrapper>
);

export default SearchStoryPreview;
